import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _class, _class2, _descriptor, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "a796b35AsdJ77YFMaISrVnJ", "Ball", undefined);

import { _decorator, Component, Node, MeshRenderer, v3, RigidBody, Vec3, SphereCollider, v2, Vec2, ERigidBodyType } from 'cc';
import { ColliderGroup, E_EventType, E_GameState, E_ResPath } from './common/EnumBase';
import { App } from './common/manager/App';
import { E_SoundType } from './common/manager/SoundManager';
import { Dove } from './Dove';
import { E_PropType, ItemBase } from './ItemBase';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var Ball = (_dec = ccclass('Ball'), _dec2 = property(Node), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Ball, _Component);

  function Ball() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "n_ps", _descriptor, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_isDie", false);

    _defineProperty(_assertThisInitialized(_this), "_ballId", 1);

    _defineProperty(_assertThisInitialized(_this), "_ballTex", new Map());

    _defineProperty(_assertThisInitialized(_this), "_mat", null);

    _defineProperty(_assertThisInitialized(_this), "_ballData", null);

    _defineProperty(_assertThisInitialized(_this), "_body", null);

    _defineProperty(_assertThisInitialized(_this), "_forwardTime", 0);

    _defineProperty(_assertThisInitialized(_this), "_t", 0);

    _defineProperty(_assertThisInitialized(_this), "_score", 2);

    return _this;
  }

  var _proto = Ball.prototype;

  _proto.onLoad = function onLoad() {
    this.initBallTex();
    this._mat = this.node.getComponentInChildren(MeshRenderer).material;
    this._body = this.node.getComponent(RigidBody);
  };

  _proto.start = function start() {
    this.addEventListenr();
    this.addColliderListener();
    this.init();
  };

  _proto.onDestroy = function onDestroy() {
    // GameCtr.I.removeEventListener();
    this.removeEventListener();
  };

  _proto.addEventListenr = function addEventListenr() {
    //球 - 皮肤更换
    App.EventMgr.addEventLintener(E_EventType.Ball_Change, this.updateBall, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.EventMgr.removeEvent(this);
    this.removeColliderListener();
  };

  _proto.addColliderListener = function addColliderListener() {
    var sphereC = this.node.getComponent(SphereCollider);
    sphereC.on("onCollisionEnter", this.onCollision, this);
    sphereC.on("onCollisionStay", this.onCollision, this);
    sphereC.on("onCollisionExit", this.onCollision, this);
    sphereC.on("onTriggerEnter", this.onTrigger, this);
  };

  _proto.removeColliderListener = function removeColliderListener() {
    var sphereC = this.node.getComponent(SphereCollider);
    sphereC.off("onCollisionEnter", this.onCollision, this);
    sphereC.off("onCollisionStay", this.onCollision, this);
    sphereC.off("onCollisionExit", this.onCollision, this);
    sphereC.off("onTriggerEnter", this.onTrigger, this);
  };

  _proto.init = function init() {
    this._ballData = {
      Magnetism: 10,
      Accelerate: 0.1
    };
    this._forwardTime = 3;

    this._body.setLinearVelocity(v3(0, 0, 0));

    this.n_ps.active = false;
    this._isDie = false;
  };

  _proto.reborn = function reborn() {
    this.node.active = true;
    this._isDie = false;
    this.node.setWorldPosition(v3(App.GameCtrl.cam_game.node.worldPosition.x, App.GameCtrl.cam_game.node.worldPosition.y + 5, 0));
  };

  _proto.onCollision = function onCollision(e) {
    var oc = e.otherCollider;
    var sc = e.selfCollider;

    if (e.type == "onCollisionEnter") {
      switch (oc.node.getComponent(RigidBody).group) {
        case ColliderGroup.LINE:
          this._t = 0;

          if (this._score != 0) {
            App.GameCtrl.score += this._score;
          }

          this._score = 0;
          App.GameCtrl.isBallStayingLine = true; // if (App.GameCtrl.isFristTouchLineAndBall) {
          //     App.GameCtrl.isFristTouchLineAndBall = false;
          // }

          this.handleLine(sc, oc); // if (App.GameCtrl.v_ballPre.y < -5) {
          //     let v_cur: Vec3 = v3();
          //     this._body.getLinearVelocity(v_cur);
          //     v_cur.y = 0;
          //     this._body.setLinearVelocity(v_cur);
          // }

          break;

        case ColliderGroup.COLLIDER:
          this.handleCollider(e);
          break;
      }
    } else if (e.type == "onCollisionExit") {
      //基本不会触发，因为meshCollider一直在动态创建，清除
      switch (oc.node.getComponent(RigidBody).group) {
        case ColliderGroup.LINE:
          // this._body.mass = 1;
          this._t = 0;
          this._score = 0;
          App.GameCtrl.isBallStayingLine = false;
          break;

        case ColliderGroup.BALL:
          break;
      }
    }
  };

  _proto.onTrigger = function onTrigger(e) {
    if (e.type == "onTriggerEnter") {
      var oc = e.otherCollider;

      if (oc.node.getComponent(RigidBody).group == ColliderGroup.PROP) {
        var propType = oc.node.getComponent(ItemBase).type;

        switch (propType) {
          case E_PropType.Dove:
            {
              this.handleProp(oc.node);
            }
            break;
        }
      }
    }
  };

  _proto.handleProp = function handleProp(n_prop) {
    var dove = n_prop.getComponent(Dove);
    if (dove.isDie) return;
    dove.isDie = true;
    App.GameCtrl.score += 50;
  };

  _proto.handleLine = function handleLine(selfCollider, oc) {
    if (App.GameCtrl.v_ballPre.y < -5) {
      var sc = selfCollider;
      var sbody = sc.node.getComponent(RigidBody);
      var v_line = v3();
      sbody.getLinearVelocity(v_line);
      sbody.setLinearVelocity(v3(App.GameCtrl.v_ballPre.x, v_line.y, 0));
    }
  }
  /**触碰到 碰撞器 */
  ;

  _proto.handleCollider = function handleCollider(e) {
    if (this._isDie) return;
    App.GameCtrl.vibrate();
    App.SoundMgr.playEffectType(E_SoundType.BallDie);
    this.handleDie();
  };

  _proto.handleDie = function handleDie() {
    if (App.GameCtrl.gameState == E_GameState.Over) return;
    this._isDie = true;
    App.EventMgr.handleEvent(E_EventType.Ball_Die);
    this.node.active = false;
    App.GameCtrl.isWin = false;
    App.EventMgr.handleEvent(E_EventType.Game_End);
  } //更新球
  ;

  _proto.updateBall = function updateBall(ballId) {
    var _this2 = this;

    if (!this._ballTex.get(ballId)) return;
    App.ResMgr.getTex(E_ResPath.Tex_BallRoot + this._ballTex.get(ballId), function (tex) {
      _this2._mat.setProperty("mainTexture", tex);
    });
  };

  _proto.update = function update(dt) {
    if (App.GameCtrl.gameState != E_GameState.Gaming) return;
    if (this._isDie) return;
    if (!this.n_ps.active) this.n_ps.active = true;
    var aimAngle = this.node.eulerAngles.clone();
    aimAngle.multiplyScalar(-1).add(v3(0, 90, 0));
    this.n_ps.eulerAngles = aimAngle;
    this.n_ps.setWorldPosition(this.node.worldPosition); // this.updateV(dt);

    this.checkDie();
    this.checkWin();
  };

  _proto.lateUpdate = function lateUpdate(dt) {
    if (App.GameCtrl.gameState != E_GameState.Gaming) return;
    if (this._isDie) return;
    if (!this.n_ps.active) this.n_ps.active = true;
    this.updateV(dt);
    this._t += dt;

    if (this._t >= 0) {
      this._score = 2 + Math.round((this._t - 1) / 0.2); // App.GameCtrl.lbl_score.string = "+" + this._score;
      // App.GameCtrl.lbl_score.node.setPosition(0, 0, 0);
    } else {
      App.GameCtrl.lbl_score.string = "";
    } // let pos_out: Vec3 = v3();
    // App.GameCtrl.cam_game.convertToUINode(App.GameCtrl.ball_game.worldPosition, App.GameCtrl.lbl_score.node, pos_out);
    // App.GameCtrl.lbl_score.node.setPosition(pos_out);

  };

  _proto.checkDie = function checkDie() {
    var posW_ball = this.node.worldPosition;
    var pos_view = v3();
    App.GameCtrl.cam_game.worldToScreen(posW_ball, pos_view);

    if (pos_view.y < App.DataMgr.hBall_minInGame) {
      this.handleDie();
    }
  }
  /**更新球的速度 */
  ;

  _proto.updateV = function updateV(dt) {
    var v_cur = v3();

    this._body.getLinearVelocity(v_cur);

    v_cur.z = 0;
    var vLen = v_cur.length();

    this._body.setAngularVelocity(v3(0, 0, vLen * (v_cur.x > 0 ? -1 : 1)));

    if (!App.GameCtrl.isBallStayingLine) {
      this._t += dt;
    }

    var v_temp = v3();
    Vec3.copy(v_temp, v_cur);
    v_temp.z = 0;
    v_temp.normalize();

    if (App.GameCtrl.isFristTouchLineAndBall) {
      v_temp.x = v_temp.x < 0 ? -v_temp.x : v_temp.x;
      App.GameCtrl.isFristTouchLineAndBall = false;

      this._body.applyForce(v_temp.multiplyScalar(5 * dt * 60));
    } else {
      var info = this.getRunDir();
      var bodyType = ERigidBodyType.DYNAMIC;

      if (info) {
        //切换body类型
        if (info.h < 0.55 && Math.abs(info.radiansLine) % Math.PI < Math.PI / 5) {
          bodyType = ERigidBodyType.KINEMATIC;
        }
      } // if (this._body.type != bodyType) {
      //     this._body.type = bodyType;
      // }


      var v_acc = App.DataMgr.accelerateOffset * App.DataMgr.accelerateLv;

      if (Math.abs(v_cur.x) < 20 + App.DataMgr.tollgateLv * 0.1) {
        if ((info === null || info === void 0 ? void 0 : info.dir) && bodyType == ERigidBodyType.KINEMATIC) {
          var offset_force = 0;

          if (info.dir.y > 0) {
            offset_force = info.dir.y / info.dir.x * 10;
          }

          this._body.applyForce(info === null || info === void 0 ? void 0 : info.dir.multiplyScalar((7 + offset_force + v_acc) * dt * 60));
        } else {
          if (v_cur.y > 10) v_cur.y = 10;

          this._body.setLinearVelocity(v_cur);

          if (info === null || info === void 0 ? void 0 : info.dir) {
            v_temp = info.dir;
          }

          this._body.applyForce(v_temp.multiplyScalar((2 + v_acc) * dt * 60));
        } // this._body.applyForce(v_temp.multiplyScalar(70));

      }

      if (bodyType == ERigidBodyType.KINEMATIC) {
        // this.node.setWorldPosition(info!.posCorrect);
        // let outRay: geometry.Ray = geometry.Ray.create(this.node.worldPosition.x, this.node.worldPosition.y, this.node.worldPosition.z, 0, -1, 0);
        // let rayResult = PhysicsSystem.instance.raycastClosest(outRay);
        // if (rayResult) {
        //     let info: PhysicsRayResult = PhysicsSystem.instance.raycastClosestResult;
        //     this.node.setWorldPosition(v3(info.hitPoint.x, info.hitPoint.y, 0).add(v3(0, 0.5, 0)));
        // }
        this._body.applyForce(info.posCorrect.multiplyScalar(7 * dt * 60));
      }
    }

    var pos_cur = this.node.worldPosition;
    pos_cur.z = 0;
    this.node.setWorldPosition(pos_cur);
    App.GameCtrl.v_ballPre = v_cur;
  };

  _proto.getRunDir = function getRunDir() {
    var posw_line = App.GameCtrl.line_game.worldPosition;
    var xw_ball = this.node.worldPosition.x;
    var yw_ball = this.node.worldPosition.y;
    var xw_lien = posw_line.x;
    var allPos = App.GameCtrl.pos_game;

    for (var i = 1; i < allPos.length; i++) {
      var pos1 = v2(allPos[i - 1].x, allPos[i - 1].y);
      var pos2 = v2(allPos[i].x, allPos[i].y);
      var pos_min = v2();
      var pos_max = v2();

      if (pos1.x > pos2.x) {
        pos_min = pos2;
        pos_max = pos1;
      } else {
        pos_min = pos1;
        pos_max = pos2;
      }

      var dir_temp1 = v2();
      var dir_temp2 = v2();
      Vec2.subtract(dir_temp1, v2(xw_ball, yw_ball), pos_min);
      Vec2.subtract(dir_temp2, pos_max, pos_min);

      if (dir_temp2.signAngle(dir_temp1) < 0) {
        continue;
      }

      if (xw_ball > allPos[i - 1].x + xw_lien && xw_ball < allPos[i].x + xw_lien) {
        var dir = v3();
        var dir_normal = v2();
        var v_cur = v3();

        this._body.getLinearVelocity(v_cur);

        if (v_cur.x < 0) {
          Vec3.subtract(dir, allPos[i - 1], allPos[i]);
          dir_normal = v2(dir.x, dir.y).rotate(Math.PI / 2).normalize();
        } else {
          Vec3.subtract(dir, allPos[i], allPos[i - 1]);
          dir_normal = v2(dir.x, dir.y).rotate(-Math.PI / 2).normalize();
        } //当前接触线段方向


        var dir_aim = v3(dir.x, dir.y, 0).normalize(); //与水平方向的夹角

        var radians_line = v2(dir_aim.x, dir_aim.y).signAngle(v2(1, 0)); //球距离线的长度

        var pos2_ball = v2(this.node.worldPosition.x, this.node.worldPosition.y);
        var pos2_c1 = v2(allPos[i - 1].x + xw_lien, allPos[i - 1].y);
        var pos2_c2 = v2(allPos[i].x + xw_lien, allPos[i].y);
        var dir_1 = v2();
        Vec2.subtract(dir_1, pos2_ball, pos2_c1);
        var dir_2 = v2();
        Vec2.subtract(dir_2, pos2_c2, pos2_c1);
        var radians = dir_2.signAngle(dir_1);
        var len_dir1 = dir_1.length();
        var h = len_dir1 * Math.sin(radians);
        var w = h / Math.tan(radians); //矫正后的球的坐标
        // let h_temp: number = 0.5;
        // let radians_correct: number = Math.atan(h_temp / w);
        // let len_temp: number = w / Math.cos(radians_correct);
        // let dir_copy: Vec3 = dir.clone();
        // dir_copy.normalize().multiplyScalar(len_temp);
        // let pos_temp: Vec2 = v2(dir_copy.x, dir_copy.y).rotate(radians_correct);
        // let pos_correct: Vec3 = v3(pos_temp.x, pos_temp.y, 0);

        var pos_temp = dir_2.clone();
        pos_temp.normalize().multiplyScalar(w).add(pos2_c1); // let pos_correct = v3();

        return {
          h: h,
          dir: dir_aim,
          radiansLine: radians_line,
          posCorrect: v3(dir_normal.x, dir_normal.y, 0)
        };
      }
    }

    return null;
  };

  _proto.checkWin = function checkWin() {
    this.node.setPosition(this.node.position.x, this.node.position.y, 0);

    if (this.node.worldPosition.x >= App.DataMgr.mapLen) {
      var v_cur = v3();

      this._body.getLinearVelocity(v_cur);

      v_cur.normalize().multiplyScalar(10);

      this._body.applyImpulse(v_cur);

      App.GameCtrl.isWin = true;
      App.EventMgr.handleEvent(E_EventType.Game_End);
    }
  };

  _proto.checkProp = function checkProp() {
    var allPropArr = App.MapCtr.propArr;
    var posOffset = v3();
    var accRange = 1 + App.DataMgr.magnetismLv * App.DataMgr.magnetismOffset;

    for (var i = 0; i < allPropArr.length; i++) {
      Vec3.subtract(posOffset, this.node.worldPosition, allPropArr[i].worldPosition);

      if (posOffset.length() <= accRange) {
        this.handleProp(allPropArr[i]);
      }
    }
  }
  /**初始化球的纹理 */
  ;

  _proto.initBallTex = function initBallTex() {
    for (var i = 1; i < 12; i++) {
      this._ballTex.set(i - 1, "ball_skin_" + i);
    }

    var arr = ["ball_skin_candy", "ball_skin_coockie", "ball_skin_egg", "ball_skin_heart", "ball_skin_orange_fruit", "ball_skin_planet_earth", "ball_skin_pokeball", "ball_skin_smile_B", "ball_skin_smile_D", "ball_skin_smile_kaka", "ball_skin_snowball", "ball_skin_threads", "ball_skin_USA"];

    for (var j = 0; j < arr.length; j++) {
      this._ballTex.set(j + 11, arr[j]);
    }
  };

  _createClass(Ball, [{
    key: "isDie",
    get: function get() {
      return this._isDie;
    },
    set: function set(v) {
      this._isDie = v;
    }
  }, {
    key: "ballId",
    get: function get() {
      return this._ballId;
    },
    set: function set(v) {
      if (this._ballId != v) {
        this._ballId = v;
        this.updateBall(v);
      }
    }
    /**球 - 纹理 */

  }]);

  return Ball;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "n_ps", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();